import React, { useEffect, useRef } from 'react';
import { useAuth } from '@/features/auth-managment/model/auth-context';
import { useCurrentLocale } from '@locales/client';
import { ItemAuth } from '../../styles';
import { BoxTelegramAuth } from './styles';

export const TelegramAuth = () => {
  const locale = useCurrentLocale();
  const { authenticationType } = useAuth();
  const containerRef = useRef<HTMLDivElement>(null);

  const configData = {
    authUrl: `${window.location.origin}/telegram/${
      authenticationType !== 'signup' ? 'login' : 'register'
    }`,
    botName:
      window.location.hostname === 'stage.pingwin.fun'
        ? process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_DEV
        : process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_PROD,
    data_text: authenticationType !== 'signup' ? 'signin' : 'signup_with',
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', configData.botName || '');
    script.setAttribute('data-auth-url', configData.authUrl);
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-lang', locale);
    script.setAttribute('data-radius', '0');

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [locale, authenticationType]);

  return (
    <ItemAuth>
      <BoxTelegramAuth ref={containerRef} />
    </ItemAuth>
  );
};
